
import useAxiosPrivate from "./useAxiosPrivate";
import {  toast } from "react-toastify";

const useDeleteGiftSku = (skuId) => {
  const Axios = useAxiosPrivate();
  const deleteSku = async () => {
    let param = { sku_id: skuId };
    const response = await Axios.post("/delete_gift_sku", param);
    const data = await response.data;
    if (data.code === 200) {
      toast.success("Deleted SuccessFully");
    } else {
      toast.error("Failed to Delete");
    }
  };
  return deleteSku;
};

export default useDeleteGiftSku;
